<template>
  <div style="margin-bottom: 4.5rem;">
    <div class="container">
      <div class="section breadcrumb" >
        <div class="header-wrapper">
            <b-breadcrumb
                align="is-left"
            >
                <b-breadcrumb-item tag='router-link' to="/insights">Insights</b-breadcrumb-item>
                <b-breadcrumb-item tag='router-link' to="/insights/dose-news" active>Daily Dose of News</b-breadcrumb-item>
            </b-breadcrumb>
            <div class="pb-title">NEWS & ANNOUNCEMENTS</div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="container">
      <div class="section py-5">
        <SearchBar class="news-columns searchbar-margin mb-5" :contentList="articleList" :dropdownList="articleTitleList" @set-content-array="setArticlesAndDataLength"/>
        <div class="columns news-columns is-multiline has-text-left mb-0 pt-5" >
          <template v-if="articles.length > 0">
            <div class="column is-12-tablet is-12-desktop py-0 mb-5" v-for="article, index in articles" :key="index">
              <p class="date">{{ formatApiDate(article.attributes.date) }}</p>
              <div class="is-flex title-wrapper">
                <div class="pb-title ">{{ article.attributes.title }} <span v-if="newBadge(article.attributes.date)" class="badge">New</span></div>
                <a @click="article.attributes.link == null ? '' : viewDetail(article.attributes.link)" :class="article.attributes.link == null ? 'text-link disabled' : 'text-link '">
                  Read More
                  <b-icon class="mr-1" icon="play" size="is-small"></b-icon>
                </a>
              </div>
              <div class="bottom-line"></div>
            </div>
          </template>
          <div v-else style="min-height: 100px; margin-inline: auto;">
            No results of news and announcements found.
          </div>
          <div v-if="(articles.length > 0 && (articleSize > dataLength && (dataLength % 6 !== 3)) && counter > 3)" class="column is-hidden-mobile" style="border-top: 1px solid #D3D3D3;"></div>
        </div>
      </div>
    </div>

     <!-- PAGINATION -->
     <div class="pb-pagination mb-1 is-hidden-mobile" v-if="articles.length > 0" >
        <b-pagination
            :total="pagination.total"
            v-model="current"
            icon-prev="menu-left"
            icon-next="menu-right"
            range-before="2"
            range-after="2"
            order="is-centered"
            :per-page="pagination.pageSize"
            @change="updateContentByPage(current)">
        </b-pagination>
      </div>

      <div class="pb-pagination mb-1 is-hidden-desktop is-hidden-tablet" v-if="articles.length > 0" >
        <b-pagination
            :total="pagination.total"
            v-model="current"
            icon-prev="menu-left"
            icon-next="menu-right"
            range-before="0"
            range-after="0"
            order="is-centered"
            :per-page="pagination.pageSize"
            @change="updateContentByPage(current)">
        </b-pagination>
      </div>

      <div class="is-flex is-justify-content-end">
        <ScrollTop />
      </div>

      <b-loading :is-full-page="isFullPage" v-model="isLoading">
          <b-icon
              pack="mdi"
              icon="loading"
              size="is-large"
              custom-class="mdi-spin">
          </b-icon>
      </b-loading>

  </div>
</template>

<script>
  import ScrollTop from '../../components/ScrollTop.vue';
  import dayjs from 'dayjs';
  import SearchBar from "../../components/SearchBar.vue";

  export default {
    components: { ScrollTop, SearchBar },
    data() {
      return {
        hideButton: false,
        dataLength: 0,
        articleSize: 6,
        articles: [],
        articleList: [],
        articleTitleList: [],
        counter: 0,
        currentPage: 1,
        current: 1,
        pagination: {},
        isLoading: false,
        isFullPage: true
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      this.updateContentByPage(1);
      
    },

    methods:{
      async updateContentByPage(pageNum) {
        this.isLoading = true 
        
        let year = dayjs().year() - 3;
        this.$httpClientCMS({
          method: 'GET',
          url: 'api/news-and-annoucements?populate=*&sort=date:desc&filters[date][$gte]=' + year + '-01-01&pagination[page]='+ pageNum + '&pagination[pageSize]=8'    
        })
        .then(resp => {
          this.isLoading = false 
          window.scrollTo({
            top: 0, 
            behavior: 'smooth',
          });

          let articles = resp.data.data;
          this.$set(this, 'articles', articles);
          this.pagination = resp.data.meta.pagination
          this.dataLength = articles.length;
          this.$set(this, 'articleList', articles);
          this.articleTitleList = articles.map(i => i.attributes.title);
        })
        .catch((error) => {
          this.isLoading = false 
          window.scrollTo({
            top: 0, 
            behavior: 'smooth',
          });

          this.$router.push('maintenance');
        });
      },
      newBadge(apiDate) {

        let today = new Date()
        let newsdate = new Date(apiDate)
        var dis = (newsdate.getTime() - today.getTime());
        let day = dis / (1000*60*60*24)

        if(day > 0 && day < 14){
          return true
        } 
        else {
          return false
        }
        
      },
      formatApiDate(apiDate){
        let formatDate = dayjs(apiDate).format('DD MMM YYYY');
        return formatDate;
      },
      loadData(){
        this.articleSize += 6;
        if(this.articleSize >= this.dataLength){
          this.hideButton = true;
        }
      },
      viewDetail(url){
        if(url!==null){
          window.open(url, '_blank').focus();
        }else{
          this.$buefy.toast.open('PDF file not available')
        }
      },
      setArticlesAndDataLength(filteredList){
        this.articles = filteredList;
        this.dataLength = filteredList.length;
      },
      setIndex(index){
        this.counter = index;
        return index;
      }
    }
  }
</script>

<style scoped lang="scss">

.title-wrapper {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  .pb-title {
    color: #363636;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: flex-start;
  }
}



.date{
  color: #363636;
  text-transform: uppercase;
  margin-bottom: 6px;
}


.badge {
  color: #363636;
  font-size: 0.8rem;
  font-weight: 400;
  letter-spacing: 0.16px;
  font-family: 'Open Sans';
  line-height: 1.5;
  margin-left: 0.5rem;
}

.bottom-line {
  margin-top: 1rem;
  border: 3px solid #730039;
}
.column{
  position: relative; 
}

.header-wrapper {
  .title {
    color: #2B2D47;
    margin-bottom: 3rem;
  }
}

.text-link{
  color: #730039;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}



.title{
  color: #2F469C;
  font-size: 41px; 
  font-weight: 700;
}

.hero {
  font-family: 'Open Sans', sans-serif !important;
}

@media screen and (min-width: 1661px) {
  .text-link {
    .icon {
      margin-left: 0.75rem
    }
  }
}

@media screen and (max-width:1023px) {
  .news-columns{
    padding: 0px !important;
  }

  .date {
    margin-bottom: 5px;
  }

  .title-wrapper {
    .pb-title {
      margin-bottom: 1rem;
    }
  }
  
  // .title{
  //   margin-bottom: 3rem !important;
  // }
}

@media screen and (max-width:893px){
  .section{
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}

@media screen and (max-width:768px){

  .title-wrapper {
    flex-direction: column;
    justify-content: left;
    align-items: start;
    .pb-title {
      display: block;
    }
  }
  .column{
    position: static; 
    width: auto !important;
    min-height: auto;
    border-top: 0px !important;
  }

  .searchbar-margin{
    margin-inline: 0em !important;
  }

  .newsDivider{
    margin-top: 3rem !important;
    border-right: 0px !important;
    padding-bottom: 0px !important;
    min-height: auto !important;
    padding-right: 20px !important;
  }
  .text-link{
    position: static; 
    bottom: auto; 
    left: auto;
    font-size: 1rem;
  }

  h2{
    margin-bottom: 10px;
  }
}
</style>
